import React from "react"
import Papa from "papaparse"

function OfferProgram(props) {
    if (props.language === 'ja_JP') {
        return <dd className="detail-body__text">{parseFreeText(props.freeText)}</dd>
    }
    else {
        return <dd className="detail-body__text">{parseFreeText(props.freeTextEn)}</dd>
    }
}

const parseFreeText = (program) => {
    if (program !== undefined) {
        let description = Papa.parse(program)
        if (description !== undefined) {
            return (
                <>
                    {description.data[0].map((item, index) => {
                        return <p key={index}> {item} </p>
                    })}
                </>
            )
        }
    }
}
export default OfferProgram
